"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateUUID = generateUUID;
exports.omit = omit;
exports.getNested = getNested;
exports.isBlank = isBlank;
exports.noop = void 0;

var noop = function noop() {};

exports.noop = noop;

function generateUUID() {
  var d = new Date().getTime();

  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); //use high-precision timer if available
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
}
/*
Returns a new object with blacklisted keys removed from an object.
*/


function omit(obj, omitArray) {
  var newObj = {};

  for (var key in obj) {
    if (omitArray.indexOf(key) < 0) {
      newObj[key] = obj[key];
    }
  }

  return newObj;
}
/*
Safely returns the value from a deeply nested object.
*/


function getNested(path, object) {
  //Short circuit of no path is given
  if (path.length <= 0) {
    return object;
  } //regex: Converts bracket object accessors to dots. // [], [''], [""]
  //split: Splits string on . and returns an array.
  //filter: Removes falsey values from array.


  path = path.replace(/[`'"\][]/g, '.').split('.').filter(function (x) {
    return x;
  }); //Checks if the child is under the parent and reduces to the final key, or returns undefined.

  return path.reduce(function (parent, child) {
    return (parent || {})[child];
  }, object);
}
/*
Check if an input value if blank
 */


function isBlank(value) {
  return value === null || value === undefined || value.trim().length === 0;
}